document.addEventListener('alpine:init', () => {
    const locale = window.locale;

    try {
        Alpine.store('jobs', {
            jobItems: [],
            perPage: 10,
            currentPage: 1,
            totalItems: 0,
            activeCategory: null,
            city: null,
            page: 1,
            category: null,

            init() {
                this.fetchDataFilter(this.city, this.category, this.page);
            },

            async fetchDataFilter(city, category, page) {
                try {
                    const params = new URLSearchParams();
                    if (city) params.append('city', city);
                    if (page) params.append('page', page);

                    params.append('perPage', this.perPage);

                    if (category) params.append('category', category);

                    const query = params.toString();
                    const url = '/api/v1/jobs' + (query ? `?${query}` : '');

                    const response = await fetch(url, {
                        headers: {'X-localization': locale}
                    });
                    const data = await response.json();

                    this.jobItems = data.data;

                    this.totalItems = data.meta ? data.meta.total : data.total;

                    if (page) this.currentPage = parseInt(page);

                    this.updatePagination();

                } catch (error) {
                    console.error(error);
                }
            },

            updatePagination() {
                const paginationContainer = document.querySelector('.pagination');
                if (!paginationContainer) return;

                paginationContainer.innerHTML = '';

                if (this.totalItems > this.perPage) {
                    this.renderPagination();
                }
            },

            generatePaginationArray() {
                const totalPages = Math.ceil(this.totalItems / this.perPage);
                if (totalPages <= 1) return [1];

                const currentPage = this.currentPage;
                const delta = 2;
                const range = [];
                const start = Math.max(2, currentPage - delta);
                const end = Math.min(totalPages - 1, currentPage + delta);

                for (let i = start; i <= end; i++) range.push(i);

                if (currentPage - delta > 2) range.unshift('...');
                if (currentPage + delta < totalPages - 1) range.push('...');

                range.unshift(1);
                if (totalPages !== 1) range.push(totalPages);

                return [...new Set(range)];
            },

            renderPagination() {
                const paginationArray = this.generatePaginationArray();
                const paginationContainer = document.querySelector('.pagination');

                paginationArray.forEach(page => {
                    if (page === '...') {
                        const dots = document.createElement('span');
                        dots.textContent = '...';
                        dots.className = 'dots';
                        paginationContainer.appendChild(dots);
                    } else {
                        const pageItem = document.createElement('div');
                        pageItem.className = `item ${page === this.currentPage ? 'item-active' : ''}`;
                        pageItem.textContent = page;

                        pageItem.addEventListener('click', () => {
                            this.currentPage = page;
                            window.scrollTo({ top: 0, behavior: "smooth" });

                            this.fetchDataFilter(this.city, this.activeCategory || this.category, page);
                        });
                        paginationContainer.appendChild(pageItem);
                    }
                });
            }
        });
    } catch (e) {
        console.log("Error", e);
    }
});
